import CarouselDivider from './CarouselDivider';

const GAMERHOOD_LOCKUP = '/assets/leaderboard/gamerhood-lockup.svg';

/**
 * Bottom photo divider on /leaderboard — image carousel with the GAMERHOOD
 * wordmark anchored to the bottom-left. Sits between the Play Along section
 * and the site footer. Mirrors Figma node 238:602.
 *
 * Background + sizing live in CarouselDivider. This file owns only the tint +
 * foreground.
 */
export default function LeaderboardDividerSection() {
  return (
    <CarouselDivider
      ariaLabel="Gamerhood"
      overlay={
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 -z-10"
          style={{
            background:
              'linear-gradient(195deg, rgba(118, 59, 190, 0) 62%, rgba(19, 6, 32, 0.6) 84%)',
          }}
        />
      }
    >
      <div className="relative mx-auto w-full max-w-[1280px]">
        <img
          src={GAMERHOOD_LOCKUP}
          alt="Gamerhood"
          className="pointer-events-none h-auto w-[clamp(200px,40vw,420px)] select-none"
        />
      </div>
    </CarouselDivider>
  );
}
